// extracted by mini-css-extract-plugin
export default {"innerWrapper":"gz-z","tooltipWrapper":"hz-z","icon":"iz-z","tooltip":"jz-z","content":"kz-z"};